export const tripadvisorUrl = (objectId: string) => `https://www.tripadvisor.com/${objectId}`;

// In the future we may want to involve language as a parameter to
// be able to link to other wikipedia domains, e.g. https://de.wikipedia.org/wiki/Pfunds_Molkerei
export const wikipediaUrl = (objectId: string) => `https://en.wikipedia.org/wiki/${objectId}`;
